export default function SwitchHorizontalIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path
                d='M20.5 17.5039H4.5M4.5 17.5039L8.5 13.5039M4.5 17.5039L8.5 21.5039M4.5 7.50391H20.5M20.5 7.50391L16.5 3.50391M20.5 7.50391L16.5 11.5039'
                stroke='#8181A5'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
